import Color from 'color'
import BaseDialog from 'components/BaseDialog'
import React, { useState } from 'react'

import { Button, Theme, Typography } from '@mui/material'
import { createStyles, withStyles, WithStyles } from '@mui/styles'

type DeleteDealButtonProps = {
  organizationReference: string
  onClick: () => void
}

const DeleteDealButton: React.SFC<DeleteDealButtonProps & WithStyles<typeof styles>> = ({
  classes,
  organizationReference,
  onClick,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  return (
    <>
      <Button
        size="small"
        color="inherit"
        variant="outlined"
        className={classes.outerDeleteButton}
        onClick={() => setDialogOpen(true)}
      >
        Delete
      </Button>
      <BaseDialog
        title="Are you sure you want to delete this deal?"
        description={
          <Typography>
            Deleting deal from <strong>{organizationReference}</strong> is a permanent action, so please proceed with
            caution.
          </Typography>
        }
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        actions={
          <Button className={classes.dialogDeleteButton} onClick={onClick}>
            Delete deal
          </Button>
        }
      />
    </>
  )
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    outerDeleteButton: {
      color: palette.extra.negative,
      marginRight: spacing(0.5),
      marginLeft: spacing(0.5),
      flex: '0 0 auto',
    },
    dialogDeleteButton: {
      color: 'white',
      backgroundColor: palette.extra.negative,
      '&:hover': {
        backgroundColor: Color(palette.extra.negative).darken(0.2).string(),
      },
    },
  })

export default withStyles(styles)(DeleteDealButton)
